import routes from 'app/company-account/routes';

export default {
  routes,
};
